import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApplicationTimeoutModal } from '../components/application-timeout-modal/application-timeout-modal';
import { ErrorModal } from '../components/error-modal/error-modal';
import { ModalService } from './modal.service';
import { AuthService } from './auth.service';

export interface LogError {
  time: Date;
  route: string;
  message: string;
  user: string;
  error: any;
}

@Injectable({
  providedIn: 'root',
})
export class LogErrorService {

  private http = inject(HttpClient);
  private auth = inject(AuthService);
  private router = inject(Router);
  private modalService = inject(ModalService);

  logErrorMessage(message: string) {
    this.logError({
      time: new Date(),
      route: this.router.url,
      message: message,
      user: this.auth.getUsername() || 'Anonymous',
      error: message
    });
  }

  logError(log: LogError): any {
    const modalRef = this.modalService.openIfNotOpen(ErrorModal, 'ErrorModal', { size: 'xl', keyboard: true });
    if ((!modalRef)) {
      return;
    }

    (<ErrorModal>modalRef.componentInstance).message.set(log.message);
    (<ErrorModal>modalRef.componentInstance).stacktrace.set(log.error?.stack || '');
    // StackTrace.fromError(log.error.error ||log.error || ).then(function (stackframes: StackFrame[]) {
    //   (<ErrorModal>modalRef.componentInstance).stacktrace.set(log.error.stack || '');
    //   console.log(stackframes);
    // });


    //modalRef.componentInstance.message = log.message;
    //this.router.navigate(['/error']); 
    //window.location.href = '/error';

    // this.http.post('http://your-api-url.com', log).subscribe(
    //   response => {
    //     console.log(response);
    //   },
    //   error => {
    //     console.error(error);
    //   }
    // );
  }
}
